var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Image, Tag } from '@philips-internal/oswald-ui-components/lib/components';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, getBreakpoint, trigger } from '@philips-internal/oswald-ui-utils';
import { bool, eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Breakpoint, SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import timeIcon from '../../assets/images/global/hpms-time.svg';
import checkIcon from '../../assets/images/global/check-green.svg';
import laboratoryIcon from '../../assets/images/avatars/avatar_lab.svg';
import './card-exams-lab-details-list-item.css';
import CardExamsLabDetailsListItemAPI from './card-exams-lab-details-list-item-api';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
const StatusExams = {
    AVAILABLE: 'A',
    PROCESSING: 'P',
    READY: 'R'
};
const ContentText = {
    AVAILABLE: 'patient.available-on',
    PROCESSING: 'patient.collected-on'
};
let CardExamsLabDetailsListItem = class CardExamsLabDetailsListItem extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            visible: true,
            width: 12
        };
    }
    static { this.propTypes = {
        dtExame: string,
        dtProcedimento: string,
        nmExame: string,
        nrPrescricao: number,
        onClick: eventListener,
        review: bool.notEnumerable(),
        status: string,
        type: string,
    }; }
    static { this.defaultProps = {
        review: false
    }; }
    getStatusInfo(status) {
        switch (status) {
            case StatusExams.AVAILABLE:
                return { expression: 'patient.available', icon: checkIcon };
            case StatusExams.PROCESSING:
                return { expression: 'patient.processing', icon: timeIcon };
            case StatusExams.READY:
                return { expression: 'patient.available', icon: checkIcon };
            default:
                return { expression: '', icon: '' };
        }
    }
    renderAvatar() {
        const breakpoint = getBreakpoint();
        const size = breakpoint === Breakpoint.LG ? Size.MEDIUM : Size.LARGE;
        return (React.createElement(Avatar, { image: laboratoryIcon, size: size }));
    }
    renderReviewTag(review) {
        if (!review) {
            return null;
        }
        return (React.createElement("div", { className: 'content-tag' },
            React.createElement(Tag, { value: MessageService.translate('patient.exam-review-tag'), color: 'signal-blue-45' })));
    }
    render() {
        const breakpoint = getBreakpoint();
        const isXSmallScreen = breakpoint === Breakpoint.XSM;
        const { onClick, nmExame, dtProcedimento, dtExame, status, review } = this.props;
        const dsDate = status === StatusExams.PROCESSING ? dtProcedimento : dtExame;
        const dateText = status === StatusExams.PROCESSING ? ContentText.PROCESSING : ContentText.AVAILABLE;
        const statusIconInfo = this.getStatusInfo(status);
        return (React.createElement(Card, { className: 'card-exams-lab-details-list-item', onClick: trigger(onClick, new ClickEvent()), width: 12, selectionType: SelectionType.SINGLE, uuid: generateUUID() },
            React.createElement("div", { className: `card-status-bar ${status}` }),
            React.createElement("div", { className: 'card-avatar' },
                this.renderAvatar(),
                React.createElement("div", { className: 'card-avatar-status' },
                    React.createElement(Image, { src: statusIconInfo.icon, className: 'status-icon', alt: '' }))),
            React.createElement("div", { className: 'card-content' },
                React.createElement("div", { className: 'card-left-content' },
                    React.createElement("div", { className: 'card-left-info-content' },
                        React.createElement("div", { className: 'content-exame-name' }, nmExame),
                        React.createElement("div", { className: 'content-physician-name' },
                            MessageService.translate(dateText),
                            " ",
                            ModelService.format('date', dsDate),
                            isXSmallScreen && this.renderReviewTag(review),
                            status === 'R' && React.createElement("span", null,
                                "  ",
                                `-  ${MessageService.translate('patient.exam.label.ready')}`,
                                " ")))),
                !isXSmallScreen &&
                    React.createElement("div", { className: 'card-right-info-content' },
                        this.renderReviewTag(review),
                        React.createElement("div", { className: 'content-date' }, ModelService.format('date', dtProcedimento))),
                React.createElement("div", { className: 'card-right-content' },
                    React.createElement("div", { className: 'content-status' },
                        React.createElement(Image, { src: statusIconInfo.icon, className: 'status-icon', alt: '' }),
                        React.createElement("div", { className: 'content-text-status' }, MessageService.translate(status ? statusIconInfo.expression : '')))))));
    }
};
CardExamsLabDetailsListItem = __decorate([
    AwesomeComponent({ api: CardExamsLabDetailsListItemAPI, type: ComponentType.DATA_DISPLAY })
], CardExamsLabDetailsListItem);
export default CardExamsLabDetailsListItem;
//# sourceMappingURL=card-exams-lab-details-list-item.js.map